import React from "react";
import { PublicListing } from "../../types/PublicListing";

interface CompanyHeaderProps {
  listing: PublicListing;
}

const CompanyHeader: React.FC<CompanyHeaderProps> = ({ listing }) => {
  const displayName = listing.companyName || listing.handle;
  const websiteHost = listing.websiteUrl
    ? (() => {
        try {
          return new URL(listing.websiteUrl).hostname.replace(/^www\./, "");
        } catch {
          return listing.websiteUrl;
        }
      })()
    : null;

  return (
    <div className="company-header">
      <div className="company-identity">
        {listing.logoUrl && (
          <img
            src={listing.logoUrl}
            alt={`${displayName} logo`}
            className="company-logo"
          />
        )}
        <div className="company-info">
          <div className="company-name">{displayName}</div>
          {websiteHost && (
            <a
              href={listing.websiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="company-website"
            >
              {websiteHost}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyHeader;
